import { capitalize } from './text'

export function getRegionFromTransportProduct(transportProduct, regions = []) {
    return regions
        .filter((r) => r.transportProduct === transportProduct)
        .map((r) => r.externalRegion || r.name)
        .map(capitalize)[0]
}
